import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import Card from "../../Components/Cards/Card";
import SubmitButton from "../../Components/Buttons/SubmitButton";
import swal from 'sweetalert';
import useSlider from "./useSlider";

export default function () {
  const { reset, handleSubmit, setErrors, setData, sliderFields } = useSlider();
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`sliders/${id}/edit`).then(res => {
      setData(res.data.data);
      reset(res.data.data.slider);
    });
  }, []);

  const editSlider = data => {
    axios.put(  `sliders/${id}`, data)
      .then(function (res) {
        if (res.status == 200) {
          swal('Slider has been updated successfully!', {
            icon: "success",
          });
          navigate("/sliders");
        }
      })
      .catch(function (error) {
        if (error.response) {
          setErrors(error.response.data.errors || {});
        }
      });
  }

  return (
    <Card title="Edit slider">
      <form className="form w-100 row" onSubmit={handleSubmit(editSlider)}>
        {sliderFields}
        <SubmitButton
          title="Update"
          classes="w-auto d-inline-block mt-4"
        />
      </form>
    </Card>
  );
}